import { useManagedListOptions } from "./useManagedListOptions.ts"

export type DocumentTypeOption = ReturnType<
  typeof useManagedListOptions
>["options"][number]

/** The company's active Document Type options, shared by every picker so they never drift. */
export function useDocumentTypeOptions(enabled = true) {
  return useManagedListOptions("document_type", enabled)
}
